<script>
    export default {
    created() {
        window.location.href = "https://haikubox.com/support-haikubox";
    }
}
</script>